import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import './Login.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      const userData = await login(email, password);

      if (userData.role === 'admin') {
        navigate('/admin-dashboard');
      } else {
        setError('You are not authorized as an admin');
        setLoading(false);
      }
    } catch (err) {
      setError(err.message || 'Invalid email or password');
      setLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <div className="login-wrapper">
        <div className="login-background-pattern"></div>
        <div className="login-container-centered">
          <motion.div
            className="login-card"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <div className="login-card-header">
              <h1>Admin Portal</h1>
              <p className="login-subtitle">Sign in to manage your clinic system</p>
            </div>

            {error && (
              <div className="alert-error">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <label>Email address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="admin@klinik.com"
                />
              </div>

              <div className="input-group">
                <label>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  placeholder="••••••••"
                />
              </div>

              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Signing in...' : 'Sign in'}
              </button>
            </form>

            <div className="login-footer">
              <button onClick={() => navigate('/')} className="link-button">
                ← Back to portal selection
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default AdminLogin;